import React, {Component} from 'react';
import {Card, Col, OverlayTrigger, Tooltip} from "react-bootstrap";
import {
    faCheck,
    faExchangeAlt,
    faExclamationTriangle,
    faFolderPlus,
    faInfo,
    faLink,
    faNotEqual,
    faTimes
} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class UniteEnseignement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ue: this.props.item
        }
    }

    updateState() {
        if (this.state.ue.CanSelect) {
            this.setState(prevState => ({
                ue: {...prevState.ue, Select: !prevState.ue.Select}
            }), () => {
                this.props.updateSelected(this.state.ue)
            })
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.item.Select !== this.props.item.Select) {
            //updateOptionsGroupees
            this.setState({ue: nextProps.item});
        } else if (nextProps.item !== this.props.item) {
            //updateIncompatibilites
            this.setState({ue: {...nextProps.item, Select: false}});
        }

        return nextProps.item !== this.props.item || this.state.ue !== nextState.ue;
    }

    render() {
        const getHeaderClass = (ue) => {
            if (ue.CreditsValides) {
                return "bg-success text-white";
            } else if (ue.IsDispense) {
                return "bg-dark text-white";
            } else if (ue.NotSelectable) {
                return "bg-danger text-white";
            } else if (!ue.Select && ue.Preselection && (ue.IsDecoche == null || ue.IsDecoche)) {
                return "clickable bg-warning text-white";
            } else if (ue.Select) {
                return "clickable bg-primary text-white";
            } else {
                return "clickable bg-light";
            }
        }

        const getBorder = (ue) => {
            if (ue.CreditsValides) {
                return "success";
            } else if (ue.IsDispense) {
                return "dark";
            } else if (ue.NotSelectable) {
                return "danger";
            } else if (!ue.Select && ue.Preselection && (ue.IsDecoche == null || ue.IsDecoche)) {
                return "warning";
            } else if (ue.Select) {
                return "primary";
            } else {
                return "";
            }
        }

        const getIcon = (ue) => {
            if (ue.CreditsValides) {
                return <FontAwesomeIcon icon={faCheck}/>;
            } else if (ue.NotSelectable) {
                return <FontAwesomeIcon icon={faTimes}/>;
            } else if (!ue.Select && ue.Preselection && (ue.IsDecoche == null || ue.IsDecoche)) {
                return <FontAwesomeIcon icon={faExclamationTriangle}/>;
            } else if (ue.Select) {
                return <FontAwesomeIcon icon={faFolderPlus}/>;
            } else {
                return null;
            }
        }

        const header = (ue) => {
            return (
                <Card.Header className={getHeaderClass(ue)}
                             onClick={this.updateState.bind(this)}>
                    <span className="float-left">
                        {ue.UniteEnseignementCode}
                    </span>
                    <span className="float-right">
                        {ue.IsDispense ? "D" : getIcon(ue)}
                    </span>
                </Card.Header>
            );
        }

        const body = (ue) => {
            return (
                <Card.Body className="d-flex align-items-center justify-content-center" style={{"height": "111px"}}>
                    <h6 className="text-primary text-center">
                        {ue.UniteEnseignementLibelle}
                    </h6>
                </Card.Body>
            );
        }

        const footer = (ue) => {
            return (
                <Card.Footer className="bg-white text-center">
                    <span className="float-left">
                        {getQuadrimeste(ue)}
                    </span>
                    <span>
                        <FontAwesomeIcon className={"text-primary fa-fw"}
                                         onClick={() => {
                                             window.open(window.location.origin + process.env.APP_ROOT + `ficheUE/${ue.UniteEnseignementID}`)
                                         }}
                                         style={{"cursor": "pointer"}}
                                         icon={faInfo}/>
                        {ue.Prerequis.length > 0 &&
                        <OverlayTrigger
                            key={`tooltip-prerequis-${ue.UniteEnseignementID}`}
                            placement={"top"}
                            overlay={
                                <Tooltip style={{fontSize: "1.25rem"}}
                                         id={`tooltip-prerequis-${ue.UniteEnseignementID}`}>
                                    <ul className={"pl-3"}>
                                        {ue.Prerequis.map(m => <li key={`prerequis-${m.RequisID}`}>{m.RequisCode}</li>)}
                                    </ul>
                                </Tooltip>
                            }
                        >
                            <FontAwesomeIcon className={"text-danger ml-3 fa-fw"} icon={faExchangeAlt}/>
                        </OverlayTrigger>
                        }
                        {ue.Corequis.length > 0 &&
                        <OverlayTrigger
                            key={`tooltip-corequis-${ue.UniteEnseignementID}`}
                            placement={"top"}
                            overlay={
                                <Tooltip style={{fontSize: "1.25rem"}}
                                         id={`tooltip-corequis-${ue.UniteEnseignementID}`}>
                                    <ul className={"pl-3"}>
                                        {ue.Corequis.map(m => <li key={`corequis-${m.RequisID}`}>{m.RequisCode}</li>)}
                                    </ul>
                                </Tooltip>
                            }
                        >
                            <FontAwesomeIcon className={"text-warning ml-3 fa-fw"} icon={faLink}/>
                        </OverlayTrigger>}
                        {ue.Incompatibilites.length > 0 &&
                        <OverlayTrigger
                            key={`tooltip-incompatible-${ue.UniteEnseignementID}`}
                            placement={"top"}
                            overlay={
                                <Tooltip style={{fontSize: "1.25rem"}}
                                         id={`tooltip-incompatible-${ue.UniteEnseignementID}`}>
                                    <ul className={"pl-3"}>
                                        {ue.Incompatibilites.map(m => <li
                                            key={`incompatible-${m.RequisID}`}>{m.RequisCode}</li>)}
                                    </ul>
                                </Tooltip>
                            }
                        >
                            <FontAwesomeIcon className={"text-dark ml-3 fa-fw"} icon={faNotEqual}/>
                        </OverlayTrigger>}
                    </span>
                    <span className="float-right">
                        {getECTS(ue)}
                    </span>
                </Card.Footer>
            )
        }

        const getQuadrimeste = (ue) => {
            return ue.Q1 && ue.Q2 ? "Q1/Q2" : ue.Q1 ? "Q1" : ue.Q2 ? "Q2" : "";
        }

        const getECTS = (ue) => {
            return ue.ECTS + (ue.ECTS !== null && " ECTS")
        }

        return (
            <Col className="mb-4" xs={12} sm={6} md={4} xl={3}>
                <Card className="shadow-sm" border={getBorder(this.state.ue)}>
                    {header(this.state.ue)}
                    {body(this.state.ue)}
                    {footer(this.state.ue)}
                </Card>
            </Col>
        );
    }
}

export default UniteEnseignement;